import { observer } from 'src/utils/mobx-react';
import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { GamblingSafetyTopBar } from 'src/domains/layouts/webview/components/gamblingSafetyTopBar/GamblingSafetyTopBar';
import { Footer } from 'src/domains/layouts/webview/modules/layoutSkeleton/Footer';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import {
    ClosureOverlay,
    ClosureStack,
    FooterBlock,
    GamblingSafetyTopSlot,
} from 'src/domains/players/webview/components/Account/closureModeComponent/ClosureModeComponent.style';
import {
    MigrationBrandBar,
    MigrationBrandBarLogo,
    MigrationBrandBarLogoWrap,
    MigrationBrandBarSlot,
    MigrationScrollable,
    MigrationStickyTopCluster,
} from './MidnightMigrationScreen.style';
import { MidnightMigrationHeroSection } from './MidnightMigrationHeroSection';
import { MidnightMigrationFeatureSection } from './MidnightMigrationFeatureSection';
import { MidnightMigrationTestimonialsSection } from './MidnightMigrationTestimonialsSection';

export const MidnightMigrationScreen = observer('MidnightMigrationScreen', (): JSX.Element => {
    const common = useCommon();
    const router = StarRouter.get(common);
    const appLayoutsState = AppLayoutsState.get(common);
    const breakpointsState = BreakpointsState.get(common);
    const { boxHeight: bannersStripHeight } = appLayoutsState.bannersBoxState;
    const { isSaferGambling } = ConfigComponents.get(common).config;
    const showGamblingSafetyStrip = isSaferGambling.available === true;
    const showMigrationBrandBarStrip = breakpointsState.desktop.isBiggerOrEq;
    const MOBILE_HEADER_HEIGHT = 48;
    const mobileHeaderHeight = breakpointsState.desktop.isBiggerOrEq === false ? MOBILE_HEADER_HEIGHT : 0;
    return (
        <ClosureOverlay
            data-test='midnight-migration-overlay'
            alreadyClosed
        >
            <ClosureStack>
                <MigrationStickyTopCluster topInset={bannersStripHeight + mobileHeaderHeight}>
                    {showMigrationBrandBarStrip ? (
                        <MigrationBrandBarSlot topInset={bannersStripHeight}>
                            <MigrationBrandBar data-test='midnight-migration-brand-bar'>
                                <MigrationBrandBarLogoWrap>
                                    <MigrationBrandBarLogo aria-label='NRG' />
                                </MigrationBrandBarLogoWrap>
                            </MigrationBrandBar>
                        </MigrationBrandBarSlot>
                    ) : null}
                    {showGamblingSafetyStrip ? (
                        <GamblingSafetyTopSlot>
                            <GamblingSafetyTopBar />
                        </GamblingSafetyTopSlot>
                    ) : null}
                </MigrationStickyTopCluster>
                <MigrationScrollable>
                    <MidnightMigrationHeroSection />
                    <MidnightMigrationFeatureSection
                        reversed={false}
                        variant='casino'
                    />
                    <MidnightMigrationFeatureSection
                        reversed={true}
                        variant='sports'
                    />
                    <MidnightMigrationTestimonialsSection />
                </MigrationScrollable>
                <FooterBlock>
                    <Footer currentView={router.currentView} />
                </FooterBlock>
            </ClosureStack>
        </ClosureOverlay>
    );
});
